/*
 * @Date: 2020-03-14 12:42:10
 * @LastEditTime: 2020-03-15 12:59:29
 * @Description: file content
 */

import Axios from 'axios'
import UploadParam from './UploadParam'
const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT || 'http://localhost:8088',
  withCredentials: true,
  headers: {
    post: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  }
})
/**
 * @typedef {import('./UploadParam').UploadParams} UploadParams
 */
/**
 * @param {UploadParams} params
 * @param {Function} callback
 */
export const uploadAudio = (params, callback) => {
  params = new UploadParam(params)
  callback = callback || (() => {})
  return axios({
    method: 'post',
    url: '/wordprison/media/upload',
    data: params.toFormData(),
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress(progressEvent) {
      if (progressEvent.lengthComputable) {
        let progress = parseInt(progressEvent.loaded / progressEvent.total * 100).toFixed(0)
        callback(progress)
      }
    }
  })
}

export const uploadFileRequest = (params, source, callback) => {
  return axios({
    method: 'post',
    url: '/wordprison/media/upload',
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    cancelToken: source.token,
    onUploadProgress(progressEvent) {
      if (progressEvent.lengthComputable) {
        let progress = parseInt(progressEvent.loaded / progressEvent.total * 100).toFixed(0)
        callback(progress)
      }
    }
  })
}
export function queryFile(data) {
  return axios({
    method: 'post',
    url: '/wordprison/media/queryFile',
    data
  })
}
export function batchUpdateDesc(data) {
  return axios({
    method: 'post',
    url: '/wordprison/media/batchUpdateDesc',
    data
  })
}
export function batchDelUploadFile(data) {
  return axios({
    method: 'post',
    url: '/wordprison/media/batchDelUploadFile',
    data
  })
}
